import React from 'react';


function StopsSort({sortOrder, setSortOrder}) {

return (
    <div className="sort-container">
    <label htmlFor="sort-select">Sortuj według: </label>
    <select 
    id="sort-select"
    value={sortOrder}
    onChange={(e) => setSortOrder(e.target.value)}
    className="sort-select"
    >
    <option value="alphabetical">Alfabetycznie</option>
    <option value="code">Kodu przystanku</option>
    <option value="distance">Odległości</option>
    </select>
    </div>
)
}

export default StopsSort;
